export default function Select({
    label,
    error,
    helperText,
    children,
    className = '',
    ...props
}) {
    return (
        <div className={`w-full ${className}`}>
            {label && (
                <label className="block text-sm font-medium mb-1.5">
                    {label}
                    {props.required && <span className="text-red ml-1">*</span>}
                </label>
            )}
            <select
                className={`input ${error ? 'border-red focus:ring-red' : ''}`}
                {...props}
            >
                {children}
            </select>
            {error && (
                <p className="mt-1 text-sm text-red">{error}</p>
            )}
            {helperText && !error && (
                <p className="mt-1 text-sm text-muted-light dark:text-muted-dark">
                    {helperText}
                </p>
            )}
        </div>
    );
}

